export default __webpack_public_path__ + "static/media/performa-invoice.02b38652.svg";